/** Bloco "1 · Qual anúncio": SKU (inclui variação), título, ID, canal e loja — comum às abas Qualidade e Divergências. */
import { Box, Button, Grid, MenuItem, Stack, TextField, Typography } from '@mui/material'
import { FILTRO_ANUNCIO_VAZIO, contaFiltroAnuncio, type FiltroAnuncio } from './logic'
import type { LojaMeta } from './types'

export function FiltroAnuncioBloco({
  valor, onChange, lojas, md = 6,
}: { valor: FiltroAnuncio; onChange: (f: FiltroAnuncio) => void; lojas: LojaMeta[]; md?: number }) {
  const canais = [...new Set(lojas.map((l) => l.marketplace))]
  const set = (k: keyof FiltroAnuncio, v: string) => {
    const novo = { ...valor, [k]: v }
    if (k === 'canal' && v && novo.loja && lojas.find((l) => l.chave === novo.loja)?.marketplace !== v) novo.loja = ''
    onChange(novo)
  }
  const n = contaFiltroAnuncio(valor)
  return (
    <Grid size={{ xs: 12, md }}>
      <Box sx={{ border: 1, borderColor: 'divider', borderRadius: 2, p: 1.25, height: '100%' }}>
        <Typography sx={{ fontSize: 10.5, textTransform: 'uppercase', letterSpacing: '.06em', color: 'text.disabled', mb: 1 }}>1 · Qual anúncio</Typography>
        <Stack spacing={1}>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1}>
            <TextField size="small" fullWidth label="SKU (inclui variação)" value={valor.sku} onChange={(e) => set('sku', e.target.value)} />
            <TextField size="small" fullWidth label="Título" value={valor.titulo} onChange={(e) => set('titulo', e.target.value)} />
            <TextField size="small" fullWidth label="ID do anúncio" placeholder="MLB, item, SKU Amazon, SPU…" value={valor.id} onChange={(e) => set('id', e.target.value)} />
          </Stack>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} alignItems={{ sm: 'center' }}>
            <TextField select size="small" fullWidth label="Canal" value={valor.canal} onChange={(e) => set('canal', e.target.value)}>
              <MenuItem value="">Todos os canais</MenuItem>
              {canais.map((c) => <MenuItem key={c} value={c}>{c}</MenuItem>)}
            </TextField>
            <TextField select size="small" fullWidth label="Loja" value={valor.loja} onChange={(e) => set('loja', e.target.value)}>
              <MenuItem value="">Todas as lojas</MenuItem>
              {lojas.filter((l) => !valor.canal || l.marketplace === valor.canal).map((l) => <MenuItem key={l.chave} value={l.chave}>{l.rotulo}</MenuItem>)}
            </TextField>
            {n ? <Button size="small" onClick={() => onChange(FILTRO_ANUNCIO_VAZIO)} sx={{ whiteSpace: 'nowrap' }}>Limpar ({n})</Button> : null}
          </Stack>
        </Stack>
      </Box>
    </Grid>
  )
}
